export default __webpack_public_path__ + "static/media/8.44f90e0f.png";